import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const CollapseMojo = props => (
  <SvgIcon
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d={
        `M16.9684 8.62613H19.8691C20.49 8.62613 20.9934 9.12949 20.9934 9.75043C20.9934 10.3714 20.49 10.8747 19.8691 10.8747H14.2476C13.6266 10.8747 13.1233 10.3714 13.1233 9.75043V4.12891C13.1233 3.50797 13.6266 3.0046 14.2476 3.0046C14.8685 3.0046 15.3719 3.50797 15.3719 4.12891V7.01837L19.0708 3.33065C19.5117 2.88978 20.2265 2.88978 20.6673 3.33065C21.1082 3.77151 21.1082 4.4863 20.6673 4.92716L16.9684 8.62613ZM4.13082 13.1235H9.75235C10.3733 13.1235 10.8767 13.6269 10.8767 14.2478V19.8694C10.8767 20.4903 10.3733 20.9937 9.75235 20.9937C9.13141 20.9937 8.62804 20.4903 8.62804 19.8694V16.9687L4.92908 20.6676L4.92256 20.6741C4.4817 21.1114 3.76983 21.1085 3.33257 20.6676L3.32605 20.6611C2.88878 20.2202 2.8917 19.5084 3.33257 19.0711L7.02029 15.3721H4.13082C3.50989 15.3721 3.00652 14.8688 3.00652 14.2478C3.00652 13.6269 3.50989 13.1235 4.13082 13.1235Z`
      }
    />
  </SvgIcon>
);

export default CollapseMojo;
